/**
 * @generated SignedSource<<403c48edc19723698e57cfc031a08c12>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProductAPIPlaygroundQuery$variables = {
  data?: string | null;
};
export type ProductAPIPlaygroundQuery$data = {
  readonly storeProductPreview: {
    readonly errors: string | null;
    readonly product: {
      readonly " $fragmentSpreads": FragmentRefs<"ProductInfoExpanded_StoreProduct">;
    } | null;
  } | null;
};
export type ProductAPIPlaygroundQuery = {
  response: ProductAPIPlaygroundQuery$data;
  variables: ProductAPIPlaygroundQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "data"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "data",
    "variableName": "data"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "errors",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "currency",
  "storageKey": null
},
v6 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Literal",
        "name": "style",
        "value": "SHORT_DATE"
      }
    ],
    "kind": "ScalarField",
    "name": "storeFormattedDate",
    "storageKey": "storeFormattedDate(style:\"SHORT_DATE\")"
  }
],
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v8 = {
  "kind": "TypeDiscriminator",
  "abstractKey": "__isProductStoreInfoComponent"
},
v9 = {
  "kind": "TypeDiscriminator",
  "abstractKey": "__isProductInfoComponentRow"
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "label",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "subTitle",
  "storageKey": null
},
v12 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "number",
      "storageKey": null
    },
    (v10/*: any*/),
    (v11/*: any*/)
  ],
  "type": "ProductInfoComponentNumberRow",
  "abstractKey": null
},
v13 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "text",
    "storageKey": null
  },
  (v10/*: any*/),
  (v11/*: any*/)
],
v14 = {
  "kind": "InlineFragment",
  "selections": (v13/*: any*/),
  "type": "ProductInfoComponentTextRow",
  "abstractKey": null
},
v15 = {
  "kind": "InlineFragment",
  "selections": (v13/*: any*/),
  "type": "ProductInfoComponentLongTextRow",
  "abstractKey": null
},
v16 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "color",
    "storageKey": null
  },
  (v10/*: any*/)
],
v17 = {
  "kind": "InlineFragment",
  "selections": [
    (v10/*: any*/),
    (v11/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "ProductInfoComponentTagsRowTag",
      "kind": "LinkedField",
      "name": "tags",
      "plural": true,
      "selections": (v16/*: any*/),
      "storageKey": null
    }
  ],
  "type": "ProductInfoComponentTagsRow",
  "abstractKey": null
},
v18 = {
  "kind": "InlineFragment",
  "selections": [
    (v10/*: any*/),
    (v11/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "ProductInfoComponentLink",
      "kind": "LinkedField",
      "name": "link",
      "plural": false,
      "selections": [
        (v10/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "url",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ProductInfoComponentLinkRow",
  "abstractKey": null
},
v19 = {
  "kind": "InlineFragment",
  "selections": [
    (v10/*: any*/),
    (v11/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "ProductInfoComponentStatus",
      "kind": "LinkedField",
      "name": "status",
      "plural": false,
      "selections": (v16/*: any*/),
      "storageKey": null
    }
  ],
  "type": "ProductInfoComponentStatusRow",
  "abstractKey": null
},
v20 = [
  (v7/*: any*/),
  (v9/*: any*/),
  (v12/*: any*/),
  (v14/*: any*/),
  (v15/*: any*/),
  (v17/*: any*/),
  (v18/*: any*/),
  (v19/*: any*/)
],
v21 = [
  (v7/*: any*/),
  (v9/*: any*/),
  (v12/*: any*/),
  (v14/*: any*/),
  (v15/*: any*/),
  (v17/*: any*/),
  (v18/*: any*/),
  (v19/*: any*/),
  {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ProductInfoComponentDetailSchema",
        "kind": "LinkedField",
        "name": "detail",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "title",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "components",
            "plural": true,
            "selections": [
              (v7/*: any*/),
              (v8/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "row",
                    "plural": false,
                    "selections": (v20/*: any*/),
                    "storageKey": null
                  }
                ],
                "type": "ProductInfoRow",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v10/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "rows",
                    "plural": true,
                    "selections": (v20/*: any*/),
                    "storageKey": null
                  }
                ],
                "type": "ProductInfoSection",
                "abstractKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "ProductInfoComponentRowInterface",
    "abstractKey": "__isProductInfoComponentRowInterface"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ProductAPIPlaygroundQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "PreviewProductResponse",
        "kind": "LinkedField",
        "name": "storeProductPreview",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "StoreProduct",
            "kind": "LinkedField",
            "name": "product",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "ProductInfoExpanded_StoreProduct"
              }
            ],
            "storageKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ProductAPIPlaygroundQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "PreviewProductResponse",
        "kind": "LinkedField",
        "name": "storeProductPreview",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "StoreProduct",
            "kind": "LinkedField",
            "name": "product",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "description",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ProductStoreStock",
                "kind": "LinkedField",
                "name": "stockInfo",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProductStoreStoreStockSchema",
                    "kind": "LinkedField",
                    "name": "store",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "quantity",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProductDistributionCenter",
                    "kind": "LinkedField",
                    "name": "otherLocations",
                    "plural": true,
                    "selections": [
                      (v3/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "availableQuantity",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ProductPrice",
                "kind": "LinkedField",
                "name": "regularPrice",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v5/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ProductStoreSpecialPrice",
                "kind": "LinkedField",
                "name": "specialPrices",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "StoreZonedDate",
                    "kind": "LinkedField",
                    "name": "startAtDate",
                    "plural": false,
                    "selections": (v6/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "StoreZonedDate",
                    "kind": "LinkedField",
                    "name": "endAtDate",
                    "plural": false,
                    "selections": (v6/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProductPrice",
                    "kind": "LinkedField",
                    "name": "price",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      (v4/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "loyaltyOnly",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ProductStorePromotions",
                "kind": "LinkedField",
                "name": "promotions",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasActivePromotion",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "components",
                "plural": true,
                "selections": [
                  (v7/*: any*/),
                  (v8/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "row",
                        "plural": false,
                        "selections": (v21/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "type": "ProductInfoRow",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v10/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "rows",
                        "plural": true,
                        "selections": (v21/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "type": "ProductInfoSection",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "imageUrl",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "partNumber",
                    "storageKey": null
                  },
                  (v3/*: any*/)
                ],
                "type": "ProductDetails",
                "abstractKey": "__isProductDetails"
              }
            ],
            "storageKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "7807a09328a8c0e1ad2badceb741cbef",
    "id": null,
    "metadata": {},
    "name": "ProductAPIPlaygroundQuery",
    "operationKind": "query",
    "text": "query ProductAPIPlaygroundQuery(\n  $data: String\n) {\n  storeProductPreview(data: $data) {\n    product {\n      ...ProductInfoExpanded_StoreProduct\n      id\n    }\n    errors\n  }\n}\n\nfragment ProductDetailsComponent on ProductStoreInfoComponent {\n  __isProductStoreInfoComponent: __typename\n  ... on ProductInfoRow {\n    row {\n      __typename\n      ...ProductDetailsRow\n    }\n    __typename\n  }\n  ... on ProductInfoSection {\n    ...ProductDetailsSection\n    __typename\n  }\n}\n\nfragment ProductDetailsComponent_ProductDetails on StoreProduct {\n  description\n  ...ProductDetailsStoreProductInfo\n  components {\n    __typename\n    ...ProductDetailsComponent\n    ... on ProductInfoRow {\n      row {\n        __typename\n        ... on ProductInfoComponentRowInterface {\n          __isProductInfoComponentRowInterface: __typename\n          detail {\n            title\n            ...ProductInfoComponentDetail_ProductInfoComponentDetailSchema\n          }\n        }\n      }\n      __typename\n    }\n    ... on ProductInfoSection {\n      rows {\n        __typename\n        ... on ProductInfoComponentRowInterface {\n          __isProductInfoComponentRowInterface: __typename\n          detail {\n            title\n            ...ProductInfoComponentDetail_ProductInfoComponentDetailSchema\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment ProductDetailsPromotions on StoreProduct {\n  promotions {\n    hasActivePromotion\n  }\n}\n\nfragment ProductDetailsRow on ProductInfoComponentRow {\n  __isProductInfoComponentRow: __typename\n  ... on ProductInfoComponentNumberRow {\n    ...ProductDetailsRowNumber\n    __typename\n  }\n  ... on ProductInfoComponentTextRow {\n    ...ProductDetailsRowText\n    __typename\n  }\n  ... on ProductInfoComponentLongTextRow {\n    ...ProductDetailsRowLongText\n    __typename\n  }\n  ... on ProductInfoComponentTagsRow {\n    ...ProductDetailsRowTags\n    __typename\n  }\n  ... on ProductInfoComponentLinkRow {\n    ...ProductDetailsRowLink\n    __typename\n  }\n  ... on ProductInfoComponentStatusRow {\n    ...ProductDetailsRowStatus\n    __typename\n  }\n}\n\nfragment ProductDetailsRowLink on ProductInfoComponentLinkRow {\n  label\n  subTitle\n  link {\n    label\n    url\n  }\n}\n\nfragment ProductDetailsRowLongText on ProductInfoComponentLongTextRow {\n  text\n  label\n  subTitle\n}\n\nfragment ProductDetailsRowNumber on ProductInfoComponentNumberRow {\n  number\n  label\n  subTitle\n}\n\nfragment ProductDetailsRowStatus on ProductInfoComponentStatusRow {\n  label\n  subTitle\n  status {\n    color\n    label\n  }\n}\n\nfragment ProductDetailsRowTags on ProductInfoComponentTagsRow {\n  label\n  subTitle\n  tags {\n    color\n    label\n  }\n}\n\nfragment ProductDetailsRowText on ProductInfoComponentTextRow {\n  text\n  label\n  subTitle\n}\n\nfragment ProductDetailsSection on ProductInfoSection {\n  label\n  rows {\n    __typename\n    ...ProductDetailsRow\n  }\n  __typename\n}\n\nfragment ProductDetailsSpecialPriceDates on ProductStoreSpecialPrice {\n  startAtDate {\n    ...StoreFormattedDate_LbzE8\n  }\n  endAtDate {\n    ...StoreFormattedDate_LbzE8\n  }\n}\n\nfragment ProductDetailsStockInfo_StoreProduct on StoreProduct {\n  stockInfo {\n    store {\n      quantity\n    }\n    otherLocations {\n      name\n      availableQuantity\n    }\n  }\n}\n\nfragment ProductDetailsStoreProductInfo on StoreProduct {\n  ...ProductDetailsStockInfo_StoreProduct\n  regularPrice {\n    value\n    currency\n  }\n  specialPrices {\n    ...ProductDetailsSpecialPriceDates\n    price {\n      currency\n      value\n    }\n    loyaltyOnly\n  }\n  ...ProductDetailsPromotions\n}\n\nfragment ProductHeader_ProductDetails on ProductDetails {\n  __isProductDetails: __typename\n  imageUrl\n  partNumber\n  name\n}\n\nfragment ProductInfoComponentDetail_ProductInfoComponentDetailSchema on ProductInfoComponentDetailSchema {\n  components {\n    __typename\n    ...ProductDetailsComponent\n  }\n}\n\nfragment ProductInfoExpanded_StoreProduct on StoreProduct {\n  id\n  ...ProductHeader_ProductDetails\n  ...ProductDetailsComponent_ProductDetails\n}\n\nfragment StoreFormattedDate_LbzE8 on StoreZonedDate {\n  storeFormattedDate(style: SHORT_DATE)\n}\n"
  }
};
})();

(node as any).hash = "1a7b17294b8349fc2583aeb06575f09d";

export default node;
